<template>
    <div class="aside-nav" v-if="items.length > 0">
        <div class="aside-nav__inner">
            <div class="aside-nav__list">
                <div :class="['aside-nav__item', item.current ? 'current' : '']" v-for="(item, i) in items" :key="i">
                    <a :href="item.url" class="aside-nav__link">{{ item.title }}</a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'AsideNav',
    props: {
        items: {
            type: Array,
            default: () => [],
        }
    },
    setup: (props, ctx) => {
        return {

        }
    },
}
</script>

<style lang="scss" scoped>
    .aside-nav {
        margin-top: 36px;
        margin-bottom: 36px;
        &__inner {
            background: #fff;
            overflow: hidden;
            border-radius: var(--br-1);
            border: 1px solid var(--c-gray-700);
        }
        &__item {
            font-weight: 600;
            font-size: 16px;
            line-height: 22px;
            border-bottom: 1px solid var(--c-gray-700);
            transition: all .3s ease;
            &:last-child {
                border-bottom: none;
            }
            &:hover {
                background: var(--c-gray-700);
            }
            &.current {
                background: var(--c-gray-600);
            }
        }
        &__link {
            color: var(--c-gray-100);
            display: flex;
            align-items: center;
            min-height: 60px;
            padding: 19px 21px;
            &:hover {
                text-decoration: none;
            }
        }
    }

    @media (max-height: 960px) {
      .aside-nav__inner {
        background-color: var(--c-gray-800);
      }
    }
</style>